//////////////////////////////////////////////////////////////////////////////////////////
//			Script zum Berechnen der Produktionszeit je Konfiguration					//
//////////////////////////////////////////////////////////////////////////////////////////

import Store from './Store.es6.js';
import DeliveryTimeCalculator from './DeliveryTimeCalculator.es6.js';
import DeliveryTimeUI from './DeliveryTimeUI.es6.js';

/*
-------------------------------------------------------------------------------------------------------
---------------------------------- Instanziierung aller Variablen -------------------------------------
-------------------------------------------------------------------------------------------------------
*/

var store = new Store();
var now = moment(window.wsDateTimeYear + '-' + window.wsDateTimeMonth + '-' + window.wsDateTimeDay + ' ' + window.wsDateTimeHours + ':' + window.wsDateTimeMinutes + ':' + window.wsDateTimeSeconds,'YYYY-MM-DD HH:mm:ss');
var versandart = sessionStorage.getItem('versandart') || 'STANDARD';

var deliveryTimeUI = new DeliveryTimeUI({
	calcDateFormat: window.ptCalcDateFormat,
	calcLanguageCode: window.pTCalcLanguageCodeISO6391 || window.ptCalcLanguageCode,
	calcUTCCorrection: window.ptCalcUTCCorrection,
	calcDeadlineOKTxt01: window.ptCalcDeadlineOKTxt01,
	calcDeadlineOKTxt02: window.ptCalcDeadlineOKTxt02,
	calcDeadlinePassedTxt01: window.ptCalcDeadlinePassedTxt01,
	calcDeadlinePassedTxt02: window.ptCalcDeadlinePassedTxt02,
	calcWT1: window.ptCalcWT1,
	calcWT2: window.ptCalcWT2,
	calcWT3: window.ptCalcWT3,
	holidayTxt: window.globalHolidayTxt,
	calcNotificationTxt01: window.ptCalcNotificationTxt01,
	calcNotificationTxt02: window.ptCalcNotificationTxt02,
	pageName: window.PageName,
	subShopId: window.subShopId,
	expressversandText: window.expressversandText
},now, $);

/* 
	Lädt das JSON mit den Feiertagen, welches notwendig ist für die Berechnung  Feiertage.
	Derzeit werden nur die deutschen Feiertage geladen
*/
var loadFeiertageRequest = function(countrycode){
	var parseDate = function(entryFromJson)
	{
		return {name : entryFromJson.text, date: moment(entryFromJson.date,'YYYY/MM/DD'), region: entryFromJson.region, type: entryFromJson.type};
	}
	var feiertageUrl = '/$WS/diedruckerei/shopdata/json/holiday/events.all.' + countrycode.toLowerCase() + '.json';
	$.getJSON(feiertageUrl).then(function(data){
		var holidays = [];
		data.events.forEach(function(day){
				var parsedDay = parseDate(day);
				holidays.push(parsedDay);
		});
		store.set('holidays_' + (countrycode || '').toLowerCase(),holidays);
	});
}('de-de');

var calculator = new DeliveryTimeCalculator('YYYY-MM-DD HH:mm:ss', now);

/*
	Berechnet und aktualisiert das Lieferdatum. Wird ausgeführt nach document.ready() und nach ws_AJAXPRResponseSuccess
*/
function updateProductionDates(){
	function calculateDurationOfProduction(types, prodDurationBasic, prodDurationAlternative) {
		if ($.inArray('TE', types) == -1 && $.inArray('TB', types) == -1 && $.inArray('T', types) == -1) {
			return prodDurationBasic;
		}
		return prodDurationAlternative;
	}

	deliveryTimeUI.moveBoxes();
	var variables = deliveryTimeUI.initializeVariables();

	if(! variables)
		return;
	
	var durationOfProduction = calculateDurationOfProduction(variables.prodTypes, variables.prodDurationBasic, variables.prodDurationAlternative);
	variables.durationOfProduction = durationOfProduction;
	variables.shippingTime = versandart == 'STANDARD' ? parseInt(window.shippingTimeProdtimeCalculation) : parseInt(window.shippingTimeProdtimeCalculationExpress);

	calculator.reset();

	/*
		Period: Ein Zeitraum, in dem produziert wird. 1. Parameter: Anzahl an Werktage dieser Periode, 2. Parameter: der Name
		noWorkRule: Gibt an, ob ein Tag ein Feiertag ist oder nicht. return true: ist kein Arbeitstag; return false: ist ein Arbeitstag.
	*/

	//Standard-Produktionstag
	calculator.addPeriod(durationOfProduction, 'PRODUKTION');
	//Zusatzproduktionstage, z.B. bei matten umschlägen,...
	calculator.addPeriod(variables.additionalDays, 'PRODUKTION', {
		additional: true
	});

	
	// Addiert Versandzeitraum
	calculator.addPeriod(variables.shippingTime || 0, 'VERSAND', {
		versandart: versandart
	});

	//Zählt nicht als Arbeitstag, wenn das Uhrzeitlimit heute schon erreicht ist (22Uhr, 12Uhr, 8Uhr,...)
	calculator.addNoWorkRule('2LATE4TODAY', function (day, index) {
		return day.date.isAfter(moment(variables.todaysDeadline, 'HH:mm')) && index == 0;
	});
	
	//Zählt nicht als Arbeitstag, wenn es Wochenende ist. 
	//Außer es ist im Versandzeitraum mit Standardversand oder Expressversand + Samstagszustellung...
	calculator.addNoWorkRule('WOCHENENDE', function (day, index) {
		var dayIsInVersandPeriod = day.originalKey == "VERSAND";
		var versandartAllowsSaturdayDelivery = versandart == 'STANDARD' || versandart == 'EXPRESS_SA';
		var isGermanShop = window.subShopId == "01-aa";
		
		if(dayIsInVersandPeriod && versandartAllowsSaturdayDelivery && isGermanShop)
			return day.date.format('E') > 6;

		return day.date.format('E') > 5;
	});

	//Zählt nicht als Arbeitstag, wenn ein Produktionstag auf einen Feiertag fällt
	calculator.addNoWorkRule('FEIERTAG_FUER_PRODUKTION', function (day, index) {
		var isFeiertag = store.get('holidays_de-de').some(function(holiday){
			var dayIsOnHoliday = holiday.date.isSame(day.date,'day');
			var dayIsInProductionPeriod = day.originalKey == "PRODUKTION";
			var isBavarianHoliday = holiday.type == "holiday" && ( holiday.region.indexOf("all") != -1 || holiday.region.indexOf("BY") != -1 );

			return dayIsOnHoliday && dayIsInProductionPeriod && isBavarianHoliday;
		});
		return isFeiertag;
	});

	//Zählt nicht als Arbeitstag, wenn ein Versandtag auf einen Feiertag fällt
	calculator.addNoWorkRule('FEIERTAG_DE_VERSAND', function (day, index) {
		var isFeiertag = store.get('holidays_de-de').some(function(holiday){
			var dayIsOnHoliday = holiday.date.isSame(day.date,'day');
			var dayIsInProductionPeriod = day.originalKey == "VERSAND";
			var isBavarianHoliday = holiday.type == "holiday" && ( holiday.region.indexOf("all") != -1 || holiday.region.indexOf("BY") != -1 );

			return dayIsOnHoliday && dayIsInProductionPeriod && isBavarianHoliday;
		});
		return isFeiertag;
	});


	var deliveryDates = calculator.calculateDates(variables);
	deliveryTimeUI.updateDates(deliveryDates.deliveryDate);

	if(versandart != 'STANDARD')
		deliveryTimeUI.updateVersandartView();

	if(window.ws_test == "yes")
		console.log(deliveryDates);
}

/*
	reagiert auf Änderungen der Variablen calculateDates, bzw. holidays_de-de; wenn eine der beiden Variablen gesetzt wird 
	(mit store.set(variablename,object);), wird diese Funktion ausgeführt.
	=> Wenn das Datum berechnet werden soll und die Feiertage geladen sind, dann berechne das Datum neu.
*/
store.watch(['calculateDates','holidays_de-de'],function(value){
	if(store.get('calculateDates') && store.get('holidays_de-de'))
	{
		updateProductionDates();
	}
});

//Datum soll berechnet werden, wenn dom Fertig geladen ist; setzt die Variable dazu
$(document).ready(function () {
	store.set('calculateDates',true);
});

//Datum soll berechnet werden, wenn ajaxrequest ausgeführt wurde; setzt die Variable dazu
$(document).on('ws_AJAXPRResponseSuccess', function () {
	store.set('calculateDates',true);
});

/*
Quickfix, solange das Skript noch nicht auf Desktop ausgerollt ist. Danach löschen und aus ws-design.1.8.4 den Aufruf entfernen. 
*/
window.ajaxProductionTimeCalculation = function(){

}


// WEBPACK FOOTER //
// ./src/scripts/op/productionTimeCalculation/productionTimeCalculation.es6.js